<template>
    <div class="flex_graphic">
        <div class="card-box">
            <h4 class="header-title m-t-0 m-b-20 text-dark">{{ $t('deals') }}</h4>
            <div v-pml-block="isLoading" style="min-height: 200px;">
                <div ref="total" v-show="hasTotalChart"></div>
                <pml-ec-pizza v-if="!hasTotalChart"></pml-ec-pizza>
            </div>
        </div>
        <div class="card-box">
            <h4 class="header-title m-t-0 m-b-20 text-dark">{{ $t('sold') }}</h4>
            <div v-pml-block="isLoading" style="min-height: 200px;">
                <div ref="sold" v-show="hasSoldChart"></div>
                <pml-ec-pizza v-if="!hasSoldChart"></pml-ec-pizza>
            </div>
        </div>
        <div class="card-box">
            <h4 class="header-title m-t-0 m-b-20 text-dark">{{ $t('lost') }}</h4>
            <div v-pml-block="isLoading" style="min-height: 200px;">
                <div ref="lost" v-show="hasLostChart"></div>
                <pml-ec-pizza v-if="!hasLostChart"></pml-ec-pizza>
            </div>
        </div>
    </div>
</template>

<script>
    import c3 from 'c3'
    import * as d3 from 'd3'

    export default {
        name: 'Overview',
        props: {
            'isLoading': {
                type: Boolean,
                required: true,
                default: false
            },
            'chartData': {
                type: Object | Boolean,
                required: true
            }
        },
        watch: {
            chartData () {
                this.buildChart()
            }
        },
        computed: {
            hasTotalChart () {
                return this.chartData && this.chartData.total.data.length
            },
            hasSoldChart () {
                return this.chartData && this.chartData.sold.data.length
            },
            hasLostChart () {
                return this.chartData && this.chartData.lost.data.length
            }
        },
        methods: {
            buildChart () {
                c3.generate({
                    bindto: this.$refs.total,
                    data: {
                        columns: this.chartData.total.data,
                        type: 'pie'
                    },
                    color: {
                        pattern: this.chartData.total.color
                    },
                    pie: {
                        label: {
                            show: false
                        }
                    },
                    legend: {
                        position: 'bottom'
                    },
                    tooltip: {
                        format: {
                            value (value, ratio, id, index) {
                                return `&nbsp;${d3.format('.1%')(ratio)} (${value})`
                            }
                        }
                    }
                })

                c3.generate({
                    bindto: this.$refs.sold,
                    data: {
                        columns: this.chartData.sold.data,
                        type: 'pie'
                    },
                    color: {
                        pattern: this.chartData.sold.color
                    },
                    pie: {
                        label: {
                            show: false
                        }
                    },
                    legend: {
                        position: 'bottom'
                    },
                    tooltip: {
                        format: {
                            value (value, ratio, id, index) {
                                return `&nbsp;${d3.format('.1%')(ratio)} (${value})`
                            }
                        }
                    }
                })

                c3.generate({
                    bindto: this.$refs.lost,
                    data: {
                        columns: this.chartData.lost.data,
                        type: 'pie'
                    },
                    color: {
                        pattern: this.chartData.lost.color
                    },
                    pie: {
                        label: {
                            show: false
                        }
                    },
                    legend: {
                        position: 'bottom'
                    },
                    tooltip: {
                        format: {
                            value (value, ratio, id, index) {
                                return `&nbsp;${d3.format('.1%')(ratio)} (${value})`
                            }
                        }
                    }
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/reports/sources/components/Overview.vue